'use strict';

angular.module('far.events')
    .controller('EventGalleryViewController', function ($log, $http, $scope, showModalMessage, $uibModal) {
        var vm = {
            progress: true,
            form: {
                id: null,
                slides_files: []
            },
            construct: function (event) {
                vm.form.id = event;

                $http.get(Routing.generate('api_event_get_event_gallery', {event: vm.form.id}))
                    .then(function (response) {
                        angular.forEach(response.data, function (image) {
                            vm.form.slides_files.push(image);
                        });

                        vm.progress = false;
                    }, function errorCallback(response) {
                        $log.error(response);
                        showModalMessage('Невозможно загрузить галерею.');

                        vm.progress = false;
                    });
            },
            openSlider: function (slide) {
                $uibModal.open({
                    templateUrl: '/modals/slider/slider.html',
                    controller: 'SliderController as slider',
                    resolve: {
                        slides: function () {
                            return vm.form.slides_files;
                        },
                        selectedSlide: function () {
                            return slide;
                        }
                    }
                });
            },
            dragend: function () {
                vm.form.slides_files = vm.form.slides_files.map(function (slide, index) {
                    slide.sort = index + 1;
                    return slide;
                });

                $http.put(Routing.generate('api_event_put_event_gallery', {event: vm.form.id}), vm.form)
                    .then(function (response) {

                    }, function errorCallback(response) {
                        $log.error(response);

                        showModalMessage('Невозможно сохранить галерею.');

                        vm.submitted = true;
                    });
            }
        };

        return vm;
    });